import { gql } from '@apollo/client';

// 查询待审核司机列表（按状态）
export const GET_DRIVERS_BY_VERIFICATION_STATUS = gql`
    query GetDriversByVerificationStatus(
        $verificationStatus: Int!,
        $filters: DriverVerificationFiltersTypeInput,
        $pageRequest: PageRequestTypeInput!
    ) {
        getDriversByVerificationStatus(
            verificationStatus: $verificationStatus,
            filters: $filters,
            pageRequest: $pageRequest
        ) {
            content {
                driverAccountId
                driverId
                name
                phone
                countryCode
                dspName
                vehicleTypeId
                vehiclePlate
                verificationStatus
                verificationTime
                reviewComment
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

// 查询司机审核详情
export const GET_DRIVER_VERIFICATION_DETAIL = gql`
    query GetDriverVerificationDetail($driverAccountId: Long!) {
        getDriverVerificationDetail(driverAccountId: $driverAccountId) {
            driverAccountId
            driverId
            name
            phone
            countryCode
            dspName
            vehicleTypeId
            vehiclePlate
            idDocumentType
            idDocumentNumber
            idDocumentImageUrls
            vehicleImageUrls
            verificationStatus
            verificationTime
            reviewComment
        }
    }
`;

// 查询司机审核历史
export const GET_DRIVER_VERIFICATION_HISTORY = gql`
    query GetDriverVerificationHistory(
        $driverAccountId: Long!,
        $pageRequest: PageRequestTypeInput!
    ) {
        getDriverVerificationHistory(
            driverAccountId: $driverAccountId,
            pageRequest: $pageRequest
        ) {
            content {
                id
                driverAccountId
                verificationStatus
                reviewerAccountId
                reviewerName
                reviewComment
                idDocumentType
                idDocumentNumber
                idDocumentImageS3Keys
                vehiclePlate
                vehicleImageS3Keys
                createdAt
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

// 导出类型定义
export type {
    DriverVerificationFiltersTypeInput,
    PageRequestTypeInput,
    DriverVerificationInfoType,
    DriverVerificationDetailType,
    DriverVerificationHistoryType,
    DriverVerificationListingResponseType,
    DriverVerificationHistoryResponseType
} from '../../types/driverVerification/DriverVerificationTypes';

